import React from "react";
import { ReactComponent as Category } from "./RoundCategory.svg";
import "./Categories.scss";

const Categories = () => <Category className="category-sty" />;

export default Categories;
